import React, { ReactNode } from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles(() => ({
  fixedScrollSection: {
    overflow: "auto",
    backgroundColor: "transparent",
  },
}));

interface IFixedScrollSection {
  children: ReactNode;
  classname?: string;
}

const FixedScrollSectionTemplate = (props: IFixedScrollSection) => {
  const { children, classname } = props;
  const classes = useStyle();
  return (
    <div className={clsx(classes.fixedScrollSection, "p-6", classname)}>
      {children}
    </div>
  );
};

export default FixedScrollSectionTemplate;
